"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.getStartDate = getStartDate;
exports.getEndDate = getEndDate;
exports.isSameMonthYear = isSameMonthYear;

var _moment = require("moment");

var _moment2 = _interopRequireDefault(_moment);

var _uiwidgetsCommon = require("uiwidgets-common");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Get the start date of an object.
 *
 * @param date {Date|object}
 * @return {Date} the start date or null.
 */
function getStartDate(date) {
    if (!date) {
        return null;
    }

    var start = date;
    while (start) {
        if (start.start) {
            start = start.start;
        } else {
            // if `start` is neither an instance of Date or moment, then we have ano end date
            if (!(0, _uiwidgetsCommon.isDate)(start) && !_moment2.default.isMoment(start)) {
                return null;
            }

            // `start` is a valid Date/moment
            break;
        }
    }

    return start;
}

/**
 * Get the end date of an object.
 *
 * @param date {Date|object}
 * @return {Date} the end date or null.
 */

function getEndDate(date) {
    if (!date) {
        return null;
    }

    var end = date;
    while (end) {
        if (end.end) {
            end = end.end;
        } else {
            // if `end` is neither an instance of Date or moment, then we have ano end date
            if (!(0, _uiwidgetsCommon.isDate)(end) && !_moment2.default.isMoment(end)) {
                return null;
            }

            // `end` is a valid Date/moment
            break;
        }
    }

    return end;
}

/**
 * Test that 2 dates have the same month and year.
 *
 * @param lhs {Date} a date object.
 * @param rhs {Date} a date object.
 * @return {boolean} true if the dates have the same month/year, otherwise false.
 */
function isSameMonthYear(lhs, rhs) {
    if (!(0, _uiwidgetsCommon.isDate)(lhs) || !(0, _uiwidgetsCommon.isDate)(rhs)) {
        return false;
    }

    return lhs.getMonth() === rhs.getMonth() && lhs.getFullYear() === rhs.getFullYear();
}
//# sourceMappingURL=utils.js.map